import EmptyIcon from '../../images/empty.svg?react';
import styles from './index.module.scss';

const Empty = () => {
  return (
    <div className={styles.empty}>
      <div className={styles.emptyIcon}>
        <EmptyIcon />
      </div>
      <div className={styles.emptyText}>There were no results, try a new search.</div>
    </div>
  );
};

export default Empty;
